import { Outlet, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import Header from '../../components/header';
import Footer from '../../components/footer';
import FloatingCartButton from './components/floating-button';

function Layout() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <>
      <Header />
      <div style={{ paddingTop: '4rem' }}>
        <Outlet />
      </div>
      <Footer />
      <FloatingCartButton />
    </>
  );
}

export default Layout;
